import React from 'react';
import ReactDOM from 'react-dom/client';
import './shared/i18n'; // i18n init (side-effect)
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
